import { useEffect, useRef, useState } from 'react';
import { Box, Tooltip } from '@chakra-ui/react';

export const ClampedTooltipText = ({ value }: { value: string }) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const element = textRef.current;

    if (!element) return;

    const updateClampedState = () => {
      setIsClamped(element.scrollHeight > element.clientHeight + 1);
    };

    const animationFrameId = window.requestAnimationFrame(updateClampedState);

    const resizeObserver = new ResizeObserver(updateClampedState);
    resizeObserver.observe(element);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      resizeObserver.disconnect();
    };
  }, [value]);

  return (
    <Tooltip
      label={value}
      hasArrow
      placement="top"
      isDisabled={!isClamped || value === '--'}
    >
      <Box
        ref={textRef}
        textStyle="textBody"
        textAlign="left"
        width="100%"
        cursor={isClamped && value !== '--' ? 'default' : 'inherit'}
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere'
        }}
      >
        {value}
      </Box>
    </Tooltip>
  );
};